module.exports = __webpack_public_path__ + "img/Abnormal.0145ec87.svg";